import { useState } from "react";
const useGeolocation = () => {
  const [state, setState] = useState({
    location: null,
    error: null,
    loading: false,
    hasCheckedPermission: false
  });
  const getLocation = () => {
    if (!navigator.geolocation) {
      setState((prevState) => ({
        ...prevState,
        error: "Geolocation is not supported by your browser",
        hasCheckedPermission: true
      }));
      return;
    }
    setState((prevState) => ({ ...prevState, loading: true }));
    const onSuccess = (position) => {
      setState({
        location: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        loading: false,
        error: null,
        hasCheckedPermission: true
      });
    };
    const onError = (error) => {
      setState({
        location: null,
        error: error.message,
        loading: false,
        hasCheckedPermission: true
      });
    };
    navigator.geolocation.getCurrentPosition(onSuccess, onError, {
      enableHighAccuracy: true,
      timeout: 1e4,
      maximumAge: 0
    });
  };
  return { ...state, getLocation };
};
export {
  useGeolocation
};
//# sourceMappingURL=useGeolocation.js.map
